export const ja: Record<string, string> = {
  // Home
  'game.title': 'ZOMBIE LAB',
  'home.play': 'プレイ',
  'home.shop': 'ショップ',
  'home.settings': '設定',

  // Weapons
  'weapon.pistol': 'ピストル',
  'weapon.shotgun': 'ショットガン',
  'weapon.smg': 'サブマシンガン',
  'weapon.rocketLauncher': 'ロケットランチャー',
  'weapon.grenade': 'グレネード',
  'weapon.select': '武器選択',
  'weapon.main': 'メイン武器',
  'weapon.sub': 'サブ武器',
  'weapon.confirm': '出撃',
  'weapon.level': 'Lv.',
  'weapon.damage': 'ダメージ',
  'weapon.fireRate': '連射速度',
  'weapon.magazine': 'マガジン',
  'weapon.reload': 'リロード',

  // Stage select
  'stage.select': 'ステージ選択',
  'stage.level': 'レベル',
  'stage.locked': 'ロック中',
  'stage.cleared': 'クリア済',
  'stage.1': '研究所',
  'stage.2': '市街地',
  'stage.3': '病院',
  'stage.4': '下水道',
  'stage.5': '軍事基地',
  'stage.6': '地下鉄',
  'stage.7': '工場',
  'stage.8': '森林',
  'stage.9': '空港',
  'stage.10': '最終研究所',

  // HUD
  'hud.remaining': 'ゾンビ残り',
  'hud.reloading': 'リロード中...',

  // Level Clear
  'clear.title': 'レベルクリア！',
  'clear.kills': '撃破数',
  'clear.coins': '獲得コイン',
  'clear.time': 'クリアタイム',
  'clear.nextLevel': '次のレベルへ',
  'clear.home': 'ホームに戻る',

  // Game Over
  'gameover.title': 'ゲームオーバー',
  'gameover.retry': 'リトライ',
  'gameover.home': 'ホームに戻る',

  // Shop
  'shop.title': 'ショップ',
  'shop.buy': '購入',
  'shop.upgrade': 'アップグレード',
  'shop.purchased': '購入済',
  'shop.maxLevel': '最大レベル',
  'shop.price': '価格',
  'shop.cost': '費用',
  'shop.coins': 'コイン',
  'shop.back': '戻る',
  'shop.tab.weapons': '武器購入',
  'shop.tab.upgrade': '武器強化',
  'shop.notEnough': 'コインが足りません',

  // Settings
  'settings.title': '設定',
  'settings.language': '言語',
  'settings.difficulty': '難易度',
  'settings.back': '戻る',
  'difficulty.easy': 'イージー',
  'difficulty.normal': 'ノーマル',
  'difficulty.hard': 'ハード',

  // Pause
  'pause.title': 'ポーズ',
  'pause.resume': '再開',
  'pause.settings': '設定',
  'pause.home': 'ホームに戻る',

  // General
  'loading': '読み込み中...',
  'back': '戻る',
};
